import { useLocation, useParams } from "react-router-dom";
import "./CadastroOperadores.css";
import { useEffect, useState } from "react";
import FormOperadores from "../FormOperadores/FormOperadores";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import OperadorService from "../../../services/OperadorService";
import RoleService from "../../../services/RolesService";

const CadastroOperadores = () => {
	const { personId, roleId } = useParams();
	const { state } = useLocation();
	const [operador, setOperador] = useState(state);
	const [role, setRole] = useState(state?.role);
	const [type, setType] = useState("");

	async function loadPerson(id) {
		const response = await OperadorService.getOperador(id);
		if (response.data) {
			setOperador(response.data);
		}
	}

	async function loadRole(id) {
		const response = await RoleService.getRole(id);
		if (response.data) {
			setRole(response.data);
		}
	}

	useEffect(() => {
		setType(personId || state ? "edicao" : "cadastro");

		if (operador) {
			setOperador(state);
			return;
		}

		if (personId) {
			loadPerson(personId);
		}
	}, [state, personId]);

	useEffect(() => {
		if (roleId) {
			loadRole(roleId);
		}
	}, [roleId]);

	return (
		<CadastroContainer>
			<FormOperadores operador={operador} type={type} role={role} />
		</CadastroContainer>
	);
};

export default CadastroOperadores;
